import { connect } from 'react-redux'
import AccountView from '../components/AccountView'
import { changeAccountTab } from "../modules/account";
import { USER_ROLES } from "../../../constants";

const mapDispatchToProps = {
  changeAccountTab
};

const mapStateToProps = (state) => ({
  account_tab: state.account_tab,
  is_store_owner: state.user.role === USER_ROLES.STORE_OWNER
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountView)


// WEBPACK FOOTER //
// ./src/layouts/Content/containers/AccountContainer.js